import { useTranslation } from 'react-i18next';
import { PayPalIcon } from '@karma/components/icons';
import { Button, Stack, Typography } from '@karma/components';
import * as ALOOMA from 'consts/alooma';
import Alooma from 'services/alooma';
import * as userActions from 'store/user/actions';
import useAction from 'hooks/useAction';

const ModalBodyPaypalDisconnect = ({ onClose }) => {
  const { t } = useTranslation();
  const contextDataAttrs = Alooma.useContextDataAttrs();
  const unsubscribePP = useAction(userActions.unsubscribePP);

  const handleDisconnect = () => {
    unsubscribePP();
    onClose();
  };

  return (
    <Stack direction="column" spacing={20}>
      <PayPalIcon width={60} height={60} />
      <Stack direction="column" spacing={8}>
        <Typography variant="h3">{t('app:areYouSureYouWantToDisconnectFromPaypal')}</Typography>
        <Typography variant="paragraphLarge">{t('app:youHaveToReconnectToWithdraw')}</Typography>
      </Stack>

      <Button
        {...contextDataAttrs}
        data-alooma-element={ALOOMA.ELEMENTS.CLOSE_PANEL}
        size="medium"
        onClick={onClose}
        fullWidth
      >
        {t('app:nevermind')}
      </Button>
      <Button
        {...contextDataAttrs}
        data-alooma-element={ALOOMA.ELEMENTS.DISCONNECT_FROM_PAYPAL}
        type="outline"
        size="medium"
        onClick={handleDisconnect}
        fullWidth
      >
        {t('app:yesDisconnect')}
      </Button>
    </Stack>
  );
};

export default ModalBodyPaypalDisconnect;
